var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"image",class:{
    'is-wide': _vm.wide,
    'is-tall': _vm.tall,
    'is-cover': _vm.cover,
  },attrs:{"src":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }